import React from 'react'
import { toast } from 'react-toastify'

import { Button, Chip } from '@clientbase/clientbase-library'
import {
  Box,
  Skeleton,
  Stack,
  Theme,
  Tooltip,
  Typography,
  useMediaQuery
} from '@mui/material'
import copy from 'copy-to-clipboard'

import IconContainer from 'components/IconContainer/IconContainer'

import { theme } from 'styles/theme'

import { getStatus } from '../../utils/utils'
interface TitleProps {
  status: string
  uuid: string
  getDetailsRecurrenceExpenses: () => Promise<void>
  isRecurrent: boolean
  recurrenceDetails: any
  expenseDetails?: any
  nestedModalCycles?: boolean
  loading?: boolean
}
const Title = ({
  isRecurrent,
  getDetailsRecurrenceExpenses,
  status,
  uuid,
  recurrenceDetails,
  expenseDetails,
  nestedModalCycles,
  loading
}: TitleProps) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down(750))

  const copyUuid = () => {
    if (!uuid) return
    copy(uuid)
    toast.success('Identificador copiado para a área de transferência')
  }

  return (
    <Stack
      width="calc(100% - 40px)"
      gap={2}
      alignItems={isMobile ? 'start' : 'center'}
      justifyContent={isMobile ? 'flex-start' : 'space-between'}
      direction={isMobile ? 'column' : 'row'}
    >
      <Stack
        direction={isMobile ? 'column' : 'row'}
        alignItems={isMobile ? 'start' : 'center'}
        gap={1}
        width={'100%'}
      >
        <Tooltip
          title={uuid ? `Identificador: ${uuid}` : ''}
          placement="top"
          onClick={copyUuid}
          arrow
          PopperProps={{
            onClick: copyUuid,
            sx: { cursor: 'pointer' }
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            gap={2}
            sx={{ cursor: uuid ? 'pointer' : 'default' }}
          >
            <IconContainer icon="paid" />
            <Typography variant="mdBold" noWrap>
              {recurrenceDetails && !nestedModalCycles
                ? 'Detalhes da recorrência'
                : 'Detalhes da despesa'}
            </Typography>
          </Stack>
        </Tooltip>

        {loading ? (
          <Skeleton
            variant="rounded"
            width={90}
            height={25}
            animation="wave"
            sx={{ borderRadius: '16px' }}
          />
        ) : (
          <Chip
            label={getStatus(status)?.label}
            sx={{
              background: getStatus(status)?.color,
              color: getStatus(status)?.fontColor,
              height: '25px',
              width: '90px',
              [theme.breakpoints.down(508)]: {
                width: '100%'
              }
            }}
          />
        )}
      </Stack>

      <Box width={isMobile ? '100%' : 'auto'}>
        {!isRecurrent &&
          !recurrenceDetails &&
          !nestedModalCycles &&
          expenseDetails?.recurrenceUuid && (
            <Button
              fullWidth={isMobile}
              onClick={() => getDetailsRecurrenceExpenses()}
              variantButton="outlined"
            >
              <Typography variant="smBold" noWrap>
                Acessar recorrência
              </Typography>
            </Button>
          )}
      </Box>
    </Stack>
  )
}

export default Title
